import App from "./App";
import React from "react";
import ReactDom from "react-dom";
import "./assets/stylesheets/index.css";

ReactDom.render(<App />, document.getElementById("authinc-app"));
